module.exports = __webpack_public_path__ + "img/profile-1.1c65e2fd.jpg";